<div class="container-fluid">
    <div class="row">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card border-0 shadow rounded-3 my-5">
                <img class="card-img-top" src="../../../../assets/header-logos.svg" alt="Card image cap">

                <div class="card-body p-4 p-sm-5">
                    <h5 class="card-title text-center mb-5 fw-light fs-5"><img class="card-img-top"
                            src="../../../../assets/kiomonitor.svg" alt="Card image cap"></h5>
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <div class="form-floating mb-3">
                            <input formControlName="username" type="text" class="form-control" id="floatingInput"
                                placeholder="username" autofocus>
                            <label for="floatingInput">Usuario</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input formControlName="password" type="password" class="form-control" id="floatingPassword"
                                placeholder="Password">
                            <label for="floatingPassword">Contraseña</label>
                        </div>
                        <div class="d-grid">
                            <button class="btn btn-primary btn-login text-uppercase fw-bold" type="submit">Iniciar
                                Sesión</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>